import { createI18n } from 'vue-i18n'
import type { App } from 'vue'
import type { Locale } from './types'

// Import translation files
import sk from './locales/sk.json'
import en from './locales/en.json'

export const defaultLocale: Locale = 'en'

export const supportedLocales: Locale[] = [ 'en', 'sk']

const messages = {
  en,
  // de,
  sk
}

const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages,
  globalInjection: true
})

export function setupI18n(app: App) {
  app.use(i18n)
  return i18n
}

export { i18n }
export default i18n
